<template>
	<div class="login">
		<div class="form-group col-sm-10 col-md-6">
			<div class="header">
				<h2 class="headline">Login</h2>
				<p class="subline">Light Scout Publisher</p>
			</div>

			<b-alert
				v-if="error"
				show
				variant="danger"
				class="error-alert"
				>{{ error }}</b-alert>

			<form class="form" @submit.prevent="submit()">
				<div class="form-label-group username-group">
					<label class="label" ref="username">
						<span class="-text">Benutzer</span>
						<b-form-input
							v-model="credentials.username"
							@keyup.enter="submit()"
							></b-form-input>
					</label>
				</div>
				<div class="form-label-group password-group">
					<label class="label">
						<span class="-text">Passwort</span>
						<b-form-input
							type="password"
							v-model="credentials.password"
							@keyup.enter="submit()"
						></b-form-input>
					</label>
				</div>
				<b-button
					:class="[ 'login-btn', { loading: loggingIn } ]"
					type="submit"
					variant="warning"
					@click="submit()"
				>
					<span>Login</span>
					<stretch v-if="loggingIn" size="25px" class="loader" background="#fff">
					</stretch>
				</b-button>
			</form>

			<p class="info text-muted">
				Das Passwort vergessen / oder Login-Daten anfordern: <a href="mailto:team@klickmeister.de">E-Mail an Klickmeister</a>
			</p>
		</div>
	</div>
</template>

<script>

import { Stretch } from 'vue-loading-spinner';

export default {
	name: 'ErcoLoginPage',
	data() {
		return {
			credentials: {
				username: '',
				password: '',
			},
			loggingIn: false,
			error: '',
		};
	},
	computed: {
		token() {
			return this.$store.state.user.token;
		},
		accessErrorStatusCode() {
			return this.$store.state.global.accessErrorStatusCode;
		},
	},
	methods: {
		submit() {
			this.loggingIn = true;

			const credentialsMissing = [];
			const credentialsSet = {
				username: 'Benutzer',
				password: 'Passwort',
			};

			Object.keys(credentialsSet).forEach((credKey) => {
				if (this.credentials[credKey].trim().length === 0) {
					credentialsMissing.push(credentialsSet[credKey]);
				}
			});

			if (credentialsMissing.length > 0) {
				this.error = `Es ${credentialsMissing.length > 1 ? 'müssen' : 'muss'} ein ${credentialsMissing.join(' und ')} angegeben werden!`;
				this.loggingIn = false;
				// return;
			}

			this.$store.dispatch('login', this.credentials)
				.catch((response) => {
					this.$store.dispatch('setAccessErrorStatusCode', response.status);
					this.loggingIn = false;
				});
		},
		getErrorMsg(statusCode) {
			switch (statusCode) {
				case 200:
				case -1:
					return '';
				case 0:
					return 'Server ist nicht erreichbar';
				case 401:
					return 'Nicht autorisiert';
				case 403:
					return 'Unbekannter Benutzer / Passwort';
				default:
					return 'Unbekanntes Problem';
			}
		},
	},
	mounted() {
		// .then(() => {
		//	this.$router.push('dashboard');
		// });
		document.title = 'Login - Light Scout Publisher';
		this.$refs.username.focus();
		this.error = this.getErrorMsg(this.accessErrorStatusCode);
	},
	watch: {
		token() {
			if (!this.$route.query.redirect) {
				this.$router.push('dashboard');
			} else {
				this.$router.push(this.$route.query.redirect);
			}
		},
		accessErrorStatusCode(newAccessErrorStatusCode) {
			this.error = this.getErrorMsg(newAccessErrorStatusCode);
		},
	},
	components: {
		Stretch,
	},
};
</script>

<style lang="scss">

	.login {
		background-color: rgba(242, 242, 242, 1);
		min-height: 100vh;
		padding-top: 3%;

		& > .form-group {
			background-color: rgba(255, 255, 255, 1);
			border: 1px solid rgba(204, 204, 204, 1);
			border-radius: 0.3rem;
			margin: 0 auto;
			padding: 2rem 4rem;

			& > .header {
				margin-bottom: 2rem;
			}

			& > .error-alert {
				width: 90%;
			}

			& > .form {
				& > .form-label-group {
					margin-bottom: 1rem;

					& > .label {
						width: 90%;

						& > .-text {
							display: inline-block;
							margin-bottom: 0.5rem;
						}
					}
				}

				& > .login-btn {
					overflow: hidden;

					&.loading {
						padding-right: 60px;
					}

					& > .loader {
						display: inline-block;
						position: absolute !important;
						margin: -2px 0 0 15px;
					}
				}
			}

			& > .info {
				margin-top: 2.5rem;

				& > [href] {
					color: rgba(240, 173, 78, 1);
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoLogin.vue?e04abdaa